import React from 'react';
import * as Styles from './steps.css'

const StepsSection = (props) => {
    return (
        <Styles.StepsWrapper>
            <div className="container">
                <Styles.StepsContent>
                    <Styles.StepsHeaderSubtitle>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr
                    </Styles.StepsHeaderSubtitle>
                    <Styles.StepsHeader>
                        Lorem ipsum dolor sit amet
                </Styles.StepsHeader>
                <Styles.P20 />
                <Styles.RoundNumber>
                    1
                </Styles.RoundNumber>
                <Styles.StepInfo>
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et !
                </Styles.StepInfo>
                <div className="column is-three-quarters" style={{ paddingTop: '10px'}}>
                <Styles.StyledImg src={'https://res.cloudinary.com/dfqkwnen0/image/upload/v1598022254/screenshot_1_jbm3de.png'} />
                </div>
                <Styles.P20 />
                <Styles.RoundNumber>
                    2
                </Styles.RoundNumber>
                <Styles.StepInfo>
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et !
                </Styles.StepInfo>
                <div className="column is-three-quarters" style={{ paddingTop: '10px'}}>
                <Styles.StyledImg src={'https://res.cloudinary.com/dfqkwnen0/image/upload/v1598022804/screenshot_2_bgyw6n.png'} />
                </div>
                <Styles.P20 />
                <Styles.RoundNumber>
                    3
                </Styles.RoundNumber>
                <Styles.StepInfo>
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et !
                </Styles.StepInfo>
                <div className="column is-two-fifths" style={{ paddingTop: '10px'}}>
                <Styles.StyledImg src={'https://res.cloudinary.com/dfqkwnen0/image/upload/v1598022968/Screenshot_3_ol8kxo.png'} />
                </div>
                </Styles.StepsContent>
            </div>
        </Styles.StepsWrapper>
    );
}

export default StepsSection;